import { useCallback, useEffect, useMemo, useState } from "react";
import API_URL from "../../config/apiConfig";

const terminal = new Set(["COMPLETED", "NO_SHOW", "REJECTED"]);
const cancelled = new Set(["CANCELLED", "REJECTED"]);

export default function MyReservations() {
  const [reservations, setReservations] = useState([]);
  const [tab, setTab] = useState("UPCOMING");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const token = localStorage.getItem("customerToken");

  const load = useCallback(async () => {
    if (!token) { setMessage("برای مشاهده رزروها ابتدا وارد حساب مشتری شوید."); setLoading(false); return; }
    try {
      const response = await fetch(`${API_URL}/api/reservations/my-reservations`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error?.message || "بارگذاری رزروها ناموفق بود.");
      setReservations(data.reservations || []);
    } catch (error) { setMessage(error.message); } finally { setLoading(false); }
  }, [token]);
  useEffect(() => { load(); }, [load]);

  const shown = useMemo(() => reservations.filter((item) => {
    if (tab === "CANCELLED") return cancelled.has(item.status);
    if (tab === "PAST") return terminal.has(item.status) || new Date(`${item.reservationDate}T${item.endTime}`) < new Date();
    return !cancelled.has(item.status) && !terminal.has(item.status) && new Date(`${item.reservationDate}T${item.endTime}`) >= new Date();
  }), [reservations, tab]);

  const cancel = async (reservation) => {
    if (!window.confirm("این رزرو لغو شود؟")) return;
    try {
      const response = await fetch(`${API_URL}/api/reservations/mine/${reservation._id}/cancel`, { method: "PATCH", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }, body: JSON.stringify({ reason: "Cancelled from My Reservations" }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error?.message || "لغو رزرو ناموفق بود.");
      setReservations((items) => items.map((item) => item._id === reservation._id ? { ...item, status: "CANCELLED" } : item));
      setMessage("رزرو لغو شد.");
    } catch (error) { setMessage(error.message); }
  };

  return <main className="min-h-screen bg-gray-50 p-4 md:p-8" dir="rtl"><section className="mx-auto max-w-3xl">
    <h1 className="mb-5 text-2xl font-bold">رزروهای من</h1>
    <div className="mb-5 flex gap-2">{[["UPCOMING","پیش رو"],["PAST","گذشته"],["CANCELLED","لغوشده"]].map(([value,label]) => <button key={value} onClick={() => setTab(value)} className={`rounded-lg px-4 py-2 ${tab === value ? "bg-primary text-white" : "bg-white"}`}>{label}</button>)}</div>
    {message && <p className="mb-4 rounded-lg bg-blue-50 p-3 text-sm">{message}</p>}
    {loading ? <p>در حال بارگذاری…</p> : shown.length === 0 ? <p className="rounded-xl bg-white p-8 text-center text-gray-500">رزروی در این بخش وجود ندارد.</p> : <div className="space-y-3">{shown.map((item) => <article key={item._id} className="rounded-xl bg-white p-5 shadow-sm"><div className="flex items-start justify-between gap-4"><div><h2 className="font-bold">{item.restaurantId?.name || "رستوران"}</h2><p className="mt-1 text-sm text-gray-600">{item.reservationDate}، ساعت {item.startTime} تا {item.endTime}</p><p className="text-sm text-gray-600">{item.partySize} نفر {item.tableId?.name ? `· میز ${item.tableId.name}` : ""}</p>{item.specialRequest && <p className="mt-2 text-sm">درخواست: {item.specialRequest}</p>}</div><span className="rounded-full bg-gray-100 px-3 py-1 text-xs">{item.status}</span></div>{["PENDING","CONFIRMED"].includes(item.status) && <button onClick={() => cancel(item)} className="mt-4 rounded-lg border border-red-300 px-4 py-2 text-sm text-red-600">لغو رزرو</button>}</article>)}</div>}
  </section></main>;
}
